import DownloadButton from 'components/DownloadButton';
import useRecording from 'data/hooks/useRecording';
import { ButtonIconProps } from 'react-rainbow-components/components/ButtonIcon';

interface DownloadCallRecordingButtonProps extends Omit<ButtonIconProps, 'icon' | 'onClick'> {
    conversationId: string;
    recordingId?: string;
}

const DownloadCallRecordingButton = ({
    conversationId,
    recordingId,
    ...buttonProps
}: DownloadCallRecordingButtonProps) => {
    const { recordingUrl } = useRecording(conversationId, recordingId);
    return (
        <DownloadButton
            {...buttonProps}
            tooltip="Download Call Recording"
            url={recordingUrl ?? ''}
            name={`${conversationId}__${recordingId}`}
            originalName={`${conversationId}__${recordingId}.wav`}
            disabled={!conversationId || !recordingId}
        />
    );
};

export default DownloadCallRecordingButton;
